import { defineStore } from 'pinia';
import http from '@/core/http';

export const accountStore = defineStore('account', {
  // other options...
  state: () => {
    return {
      accessToken: '',
      user: undefined,
    };
  },
  actions: {
    setToken(value) {
      this.accessToken = value;
    },
    Login(userInfo) {
      return new Promise((resolve, reject) => {
        http.post('/admin/login/login', userInfo)
          .then((response) => {
            if (response.code === 100) {
              const result = response.result;
              // 站点整合后，token值作为判断是否登录依据
              this.accessToken = result.token;
              resolve();
            } else {
              reject(response);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    GetInfo () {
      return new Promise((resolve, reject) => {
        http.get('/admin/admin/myinfo').then(response => {
          if (response.code === 100) {
            // 用户数据
            const { nick, phone } = response.result;

            // 设置用户权限列表
            const permissionList = ['all'];

            // 根据用户权限设置可访问路由菜单
            if (permissionList.length > 0) {
              
              this.user = {
                name: nick,
                mobile: phone
              };
            } else {
              reject(new Error('getInfo: roles must be a non-null array !'));
            }
            resolve();
          } else if (response.code !== 110) {
            // VM.$notification.error({
            //   message: response.msg,
            // });
          }
        }).catch(error => {
          reject(error);
        });
      });
    },
    Logout() {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve();
        }, 1500);
      });
    },
  },
  // 存储在本地
  persist: {
    enabled: true,
    strategies: [
      { storage: localStorage }
    ]
  }
});